import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, ArrowRight } from "lucide-react";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import Logo from "@/components/site/Logo";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  const field =
    "w-full bg-transparent border-b border-white/20 py-3 text-lg text-white outline-none transition-colors focus:border-violet placeholder:text-white/30";

  return (
    <div className="min-h-screen bg-ink text-white flex items-center justify-center px-6" data-testid="login-page">
      <div className="w-full max-w-md">
        <Logo className="h-20" white to={null} />
        <h1 className="mt-12 font-display font-extrabold tracking-tighter text-5xl">Espace admin</h1>
        <p className="mt-3 text-white/50">Gérez votre portfolio et vos messages.</p>

        <form onSubmit={submit} className="mt-10 space-y-8" data-testid="login-form">
          <div>
            <label className="text-sm text-white/50">Email</label>
            <input type="email" className={field} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@equinoxe-studio.fr" data-testid="login-email" />
          </div>
          <div>
            <label className="text-sm text-white/50">Mot de passe</label>
            <input type="password" className={field} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" data-testid="login-password" />
          </div>
          {error && <p className="text-red-400 text-sm" data-testid="login-error">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="group inline-flex items-center gap-3 bg-white text-ink px-8 py-4 hover:bg-violet hover:text-white transition-colors duration-300 disabled:opacity-60"
          >
            {loading ? <Loader2 className="animate-spin" size={18} /> : <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />}
            {loading ? "Connexion…" : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}
